import entraConfig from "entra-config";

export const msalConfig = {
  auth: {
    authority: `https://login.microsoftonline.com/${entraConfig.tenantId}`,
    clientId: entraConfig.clientId,
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
};

export const tokenRequest = {
  scopes: [`api://${entraConfig.clientId}/MACT.Access`],
};
